module.exports = __webpack_public_path__ + "img/wave-footer.cc9b5353.svg";